import React from 'react';
import Overlay from '../../partials/white_overlay';

const POO = () => {
    return (
        <div style={{ position: 'relative' }}>
            <Overlay />
            <div className="p-4 hind" style={{ mixBlendMode: 'screen' }}>
                <h2 className="hind">Playoff Overtime</h2>
                <p>Playoff games that end regulation in a tie shall play a sudden death overtime period with a maximum length of three minutes. A coin toss will decide kick-off direction. The first team to score in overtime is the winner. If no team has scored in the three-minute overtime period, the winner shall be decided by shootout.</p>

                <p>Three (3) players from each team will be used and the coach should notify the referee the order in which each one will kick - this will be identified as a "Kicking Round" -. A coin flip will give the winning team the option to decide who starts the kicking round. Teams will alternate kickers for three (3) rounds based on this order. After each player has taken their initial kick, the team with the most goals wins.</p>

                <p>If the score remains tied, then the game goes into "Sudden Death Penalty Kicks" - this is a single kicking round until there's a clear winner -. The kicking order is based on the initial kicking order listed out above</p>
            </div>
        </div>
    );
}

export default POO;



// WEBPACK FOOTER //
// ./src/components/rules/partials/poo.js